@let loading = isLoading();
@let requestSending = isRequestSending();

<div>
  <div class="branch-name" mat-dialog-title style="margin-bottom: 5px; color: white">{{ branchName }}: {{ locationName }}</div>

  <h1 class="pl-2 my-2 text-2xl font-bold tracking-tight text-gray-900 text-center">Allowed Emails</h1>

  <table [dataSource]="loginUsers()" class="mat-elevation-z0 user-table" mat-table>
    <!-- User email Column -->
    <ng-container matColumnDef="user-email">
      <th *matHeaderCellDef mat-header-cell>User email</th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.email }}
      </td>
    </ng-container>

    <!-- Action Column: Delete -->
    <ng-container matColumnDef="action">
      <th
        *matHeaderCellDef
        mat-header-cell
        matTooltip="Delete the user from this location's list of users.
      Note: All Access and Permissions for the user should be disabled first."
        matTooltipClass="multiline-tooltip"
        matTooltipPosition="above"
      >
        Action
      </th>

      <td *matCellDef="let element" mat-cell>
        <button
          (click)="removeUser(element)"
          [disabled]="requestSending"
          aria-label="delete user"
          class="material-icons remove-icon btn-remove"
          mat-icon-button
          matTooltip="Delete User"
          matTooltipPosition="left"
        >
          <mat-icon>remove_circle</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
  </table>

  @if (loading) {
    <div class="p-2">
      <p style="padding: 6px; color: dimgrey; font-size: 12px">Loading emails...</p>
    </div>
  }

  @if (!loading && loginUsers().length === 0) {
    <div class="p-2">
      <p style="padding: 6px; color: dimgrey; font-size: 12px">There are currently no emails connected to this location</p>
      <mat-divider style="padding-bottom: 6px"></mat-divider>
    </div>
  }

  <div class="p-2">
    <div style="color: red; font-size: 12px">
      <p>{{ message() }} </p>
    </div>

    <form #formDirective="ngForm" (ngSubmit)="addUser()" [formGroup]="userForm" class="add-user-form">
      <div style="flex-grow: 1">
        <mat-form-field appearance="fill" class="add-user-form-field">
          <mat-label>User email</mat-label>
          <input
            aria-label="user email"
            formControlName="email"
            matInput
            pattern="^([\w\.\-]+)@([\w\-]+)((\.(\w){2,4})+)$"
            placeholder="Enter new email"
            type="email"
          />
          @if (selectedUserEmail || userForm.get("email").value) {
            <button (click)="clearEmail()" aria-label="Clear" mat-icon-button matSuffix type="reset">
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
      <button [disabled]="requestSending || isEmailInputInvalid()" class="btn-add-user" mat-stroked-button type="submit">Add User</button>
    </form>
  </div>

    <div>
      <h1 class="pl-2 my-2 text-2xl font-bold tracking-tight text-gray-900 text-center">Allowed Domains</h1>

      <table [dataSource]="domains" class="mat-elevation-z0 user-table" mat-table>
        <!-- Domain Column -->
        <ng-container matColumnDef="user-email">
          <th *matHeaderCellDef mat-header-cell>Domain</th>
          <td *matCellDef="let element" mat-cell matTooltipClass="multiline-tooltip" matTooltipPosition="above">
            {{ element.domain }}
          </td>
        </ng-container>
        <!-- Action Column: Delete -->
        <ng-container matColumnDef="action">
          <th
            *matHeaderCellDef
            mat-header-cell
            matTooltip="Delete the domain from this location's list of domains."
            matTooltipClass="multiline-tooltip"
            matTooltipPosition="above"
          >
            Action
          </th>
          <td *matCellDef="let element" mat-cell>
            <button
              (click)="removeDomain(element)"
              [disabled]="requestSending"
              aria-label="delete user"
              class="material-icons remove-icon btn-remove"
              mat-icon-button
              matTooltip="Delete Domain"
              matTooltipPosition="left"
            >
              <mat-icon>remove_circle</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
      </table>

      @if (domains.length === 0) {
        <div class="p-2">
          <p style="padding: 6px; color: dimgrey; font-size: 12px">There are currently no domains added to this location</p>
          <mat-divider style="padding-bottom: 6px"></mat-divider>
        </div>
      }

      <div class="p-2">
        <div style="color: red; font-size: 12px">
          <p>{{ domainFormMessage() }}</p>
        </div>

        <form #formDirective="ngForm" (ngSubmit)="addDomain()" [formGroup]="domainForm" class="add-user-form">
          <div style="flex-grow: 1">
            <mat-form-field appearance="fill" class="add-user-form-field">
              <mat-label>Domain</mat-label>
              <input
                aria-label="domain"
                formControlName="domain"
                matInput
                [pattern]="domainRegex"
                placeholder="Enter a domain"
                type="url"
              />
            </mat-form-field>
          </div>

          <button [disabled]="requestSending || isDomainInputInvalid()" class="btn-add-user" mat-stroked-button type="submit">
            Add Domain
          </button>
        </form>
      </div>
    </div>

  <mat-dialog-actions align="end" style="margin-bottom: 0">
    <button [mat-dialog-close]="true" cdkFocusInitial mat-button>Close</button>
  </mat-dialog-actions>
</div>
